// Lib
import {
    ALL_TIME,
    PREVIOUS_WEEK,
    LAST_7_DAYS,
    PREVIOUS_MONTH,
    LAST_30_DAYS,
    LAST_3_MONTHS,
    THIS_YEAR,
    PREVIOUS_YEAR,
    CURRENT_QUARTER,
    PREVIOUS_QUARTER,
    CUSTOM,
    LAST_DAY,
    CURRENT_WEEK,
    CURRENT_MONTH
} from '@/lib/periods';

export const periodsVariant = {
    analytics: [
        PREVIOUS_WEEK,
        LAST_7_DAYS,
        LAST_30_DAYS,
        PREVIOUS_MONTH,
        LAST_3_MONTHS,
        THIS_YEAR,
        PREVIOUS_YEAR,
        CUSTOM
    ],
    analyticsCompetitors: [
        PREVIOUS_WEEK,
        LAST_7_DAYS,
        CURRENT_MONTH,
        LAST_30_DAYS,
        PREVIOUS_MONTH,
        CURRENT_QUARTER,
        LAST_3_MONTHS,
        CUSTOM
    ],
    analyticsHashtags: [PREVIOUS_WEEK, LAST_7_DAYS, CURRENT_MONTH, LAST_30_DAYS, CUSTOM],
    medias: [ALL_TIME, LAST_7_DAYS, LAST_30_DAYS, LAST_3_MONTHS, CUSTOM],
    myprofile: [
        ALL_TIME,
        PREVIOUS_WEEK,
        LAST_7_DAYS,
        LAST_30_DAYS,
        PREVIOUS_MONTH,
        LAST_3_MONTHS,
        THIS_YEAR,
        PREVIOUS_YEAR,
        CUSTOM
    ],
    album: [CUSTOM],
    exports_edit: [
        LAST_DAY,
        PREVIOUS_WEEK,
        CURRENT_WEEK,
        CURRENT_MONTH,
        LAST_30_DAYS,
        PREVIOUS_MONTH,
        CURRENT_QUARTER,
        PREVIOUS_QUARTER,
        THIS_YEAR,
        PREVIOUS_YEAR
    ],
    exports_max_30_days_edit: [LAST_DAY, PREVIOUS_WEEK, CURRENT_WEEK, CURRENT_MONTH, LAST_30_DAYS],
    exports_max_30_days: [
        LAST_DAY,
        PREVIOUS_WEEK,
        CURRENT_WEEK,
        CURRENT_MONTH,
        LAST_30_DAYS,
        CUSTOM
    ],
    exports_max_90_days_edit: [
        LAST_DAY,
        PREVIOUS_WEEK,
        CURRENT_WEEK,
        CURRENT_MONTH,
        LAST_30_DAYS,
        PREVIOUS_MONTH,
        CURRENT_QUARTER,
        LAST_3_MONTHS
    ],
    exports_max_90_days: [
        LAST_DAY,
        PREVIOUS_WEEK,
        CURRENT_WEEK,
        CURRENT_MONTH,
        LAST_30_DAYS,
        PREVIOUS_MONTH,
        CURRENT_QUARTER,
        LAST_3_MONTHS,
        CUSTOM
    ],
    exports: [
        LAST_DAY,
        PREVIOUS_WEEK,
        CURRENT_WEEK,
        CURRENT_MONTH,
        LAST_30_DAYS,
        PREVIOUS_MONTH,
        CURRENT_QUARTER,
        PREVIOUS_QUARTER,
        PREVIOUS_YEAR,
        THIS_YEAR,
        CUSTOM
    ]
} as const;

export type PeriodsVariantType = typeof periodsVariant;
